import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SseService } from 'src/app/services/SseService';
import { VentanaMinimizable } from 'src/app/utils/ventana-minimizable.util';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { TemaService } from 'src/app/services/tema.services';
import { Subscription } from 'rxjs';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-dialog-condicion',
  templateUrl: './dialog-condicion.component.html',
  styleUrls: ['./dialog-condicion.component.scss']
})
export class DialogCondicionComponent implements OnInit {
  public condicionForm: FormGroup;
  public loading: boolean = false;
  public isDark: boolean = false;
  private temaSubscription: Subscription;
  public token: string = '';
  public conditionParts: { isNumber: boolean; value: string }[] = [];
  public numberValues: number[] = [];
  public numberControlMapping: { [key: number]: string } = {};
  theme: string = 'light';
  constructor(
    private dialogRef: MatDialogRef<DialogCondicionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { condicion: any, indicatorsIaSinEspacios: string[], origen: any, theme: string, flotante?: boolean },
    private fb: FormBuilder,
    private sseService: SseService,
    private cookieService: CookieService,
    private toastr: ToastrService
  ) {
    this.ventana = new VentanaMinimizable(this.dialogRef, !!this.data?.flotante, '500px');
  }

  /** Minimizar/restaurar cuando se abre como ventana flotante (data.flotante). */
  ventana: VentanaMinimizable;

  ngOnInit(): void {
    // Obtain token
    this.token = this.cookieService.get('auth_token');
    
    // Parse the condition into text and number parts
    const conditionLabel = this.data.condicion.label || '';
    this.theme = this.data.theme || 'light';
    this.parseComplexCondition(conditionLabel);
    
    // Create the form with dynamic number controls
    const formConfig: { [key: string]: any } = {
      label: [conditionLabel, [Validators.required]],
      type: [this.data.condicion.type || '', [Validators.required]]
    };
    
    // Add number controls dynamically based on how many numbers were found
    let numberIndex = 0;
    this.conditionParts.forEach((part, index) => {
      if (part.isNumber) {
        const controlName = `number${numberIndex}`;
        formConfig[controlName] = [this.numberValues[numberIndex], [Validators.required]];
        this.numberControlMapping[index] = controlName;
        numberIndex++;
      }
    });
    
    this.condicionForm = this.fb.group(formConfig);

    // Update the label whenever any number value changes
    this.numberValues.forEach((_, index) => {
      this.condicionForm.get(`number${index}`)?.valueChanges.subscribe(() => {
        this.updateLabel();
      });
    });
  }

  // Get the control name for a specific index in the conditionParts array
  public getNumberControlName(index: number): string {
    return this.numberControlMapping[index] || '';
  }

  // Parse condition into text parts and number parts
  private parseComplexCondition(condition: string): void {
    // Regex to find all numbers in the string
    const numberRegex = /(\d+)/g;
    let match;
    let lastIndex = 0;
    this.conditionParts = [];
    this.numberValues = [];
    
    // Find all numbers and split the string
    while ((match = numberRegex.exec(condition)) !== null) {
      // Add text before this number
      if (match.index > lastIndex) {
        this.conditionParts.push({
          isNumber: false,
          value: condition.substring(lastIndex, match.index)
        });
      }
      
      // Add the number
      this.conditionParts.push({
        isNumber: true,
        value: match[0]
      });
      
      // Store the numeric value
      this.numberValues.push(parseInt(match[0], 10));
      
      lastIndex = match.index + match[0].length;
    }
    
    // Add any remaining text after the last number
    if (lastIndex < condition.length) {
      this.conditionParts.push({
        isNumber: false,
        value: condition.substring(lastIndex)
      });
    }
    
    // If no numbers found, treat the whole string as fixed text
    if (this.conditionParts.length === 0) {
      this.conditionParts.push({
        isNumber: false,
        value: condition
      });
    }
  }
  
  // Update the label based on current number values
  private updateLabel(): void {
    let newLabel = '';
    let numberIndex = 0;
    
    for (const part of this.conditionParts) {
      if (part.isNumber) {
        const formValue = this.condicionForm.get(`number${numberIndex}`)?.value;
        newLabel += formValue !== null && formValue !== undefined ? formValue : '';
        numberIndex++;
      } else {
        newLabel += part.value;
      }
    }
    
    this.condicionForm.get('label')?.setValue(newLabel);
  }

  ngOnDestroy(): void {
    if (this.temaSubscription) {
      this.temaSubscription.unsubscribe();
    }
  }

  onSubmit(): void {
    if (this.condicionForm.invalid) {
      this.toastr.error('Por favor complete todos los campos requeridos');
      return;
    }
    
    this.loading = true;

    let condition = this.condicionForm.value.label;
    console.log('Condición a procesar:', condition);
    let condicionjson = '';
    let processedCount = 0;
    let indicaorestemp: string[] = [];
            let condicionreemplazada = this.replaceWithIndicators(condition.trim(), indicaorestemp)
    console.log('Condición reemplazada:', condicionreemplazada);
            this.sseService.apiPostNew('conditions/get_conditions', JSON.stringify({ input: condicionreemplazada }), this.token).subscribe({
                next: (response: any) => {
                    //this.isLoadingCondiciones = false;

                    console.log('Respuesta del endpoint:', JSON.stringify(response));

                    let finalSentence = this.restoreWithOriginalWords(JSON.stringify(response), indicaorestemp);
                    let interpretacionData = JSON.parse(finalSentence);
                    let condicionuno = interpretacionData.output[0];
                    console.log('Condición interpretada:', condicionuno);
                    if (processedCount === 0) {
                        condicionjson = JSON.stringify(condicionuno); // condicionuno to string 

                    } else {
                        condicionjson += ',' + JSON.stringify(condicionuno);
                    }
                    


                    const condicionActualizada = {
                      ...this.data.condicion,
                      label: this.condicionForm.value.label,
                      type: this.condicionForm.value.type,
                    };
                    
                    this.sseService.apiPostNew('actualizarcondicion', {
                      id: condicionActualizada.idindicador,
                      indicador: condicionActualizada.label,
                      json: condicionjson,
                      origen: this.data.origen
                    }, this.token).subscribe({
                      next: (response: any) => {
                        this.loading = false;
                        if (response && response.status) {
                          this.toastr.success('Condición actualizada correctamente');
                          this.dialogRef.close(condicionActualizada);
                        } else {
                          this.toastr.error(response.message || 'Error al actualizar la condición');
                        }
                      },
                      error: (error) => {
                        this.loading = false;
                        this.toastr.error('Error al actualizar la condición');
                        console.error('Error al actualizar la condición:', error);
                      }
                    });

                }
            });





    
  }
  restoreWithOriginalWords(sentence: string, wordsToReplace: string[]): string {
        let words = sentence.split('"');
        words = words.map(word => {
            if (word.startsWith('indicador')) {
                const index = parseInt(word.replace('indicador_', '')) - 1;
                return wordsToReplace[index].replaceAll('_', ' ');
            }
            return word;
        });

        return words.join('"');
    }
    replaceWithIndicators(sentence: string, indicadoresIA: string[]): string {
        let words = sentence.split(' ');
        let indicatorIndex = 1;
        console.log("Estos son los indicadores: ");
        console.log(this.data);
        words = words.map(word => {
            const index = this.data.indicatorsIaSinEspacios.indexOf(word);
            if (index !== -1) { indicadoresIA.push(word) }
            return index !== -1 ? `indicador_${indicatorIndex++}` : word;
        });

        return words.join(' ');
    }

  onCancel(): void {
    this.dialogRef.close();
  }
}